const checkIsWindowPopupBlocked = (newWindow: Window): boolean => (
    !newWindow
    || newWindow.closed
    || newWindow.closed === undefined
);

export default checkIsWindowPopupBlocked;
